import { GET_ROSTER } from '../bridge-methods';

const emptyArray = [];

export function getAllStudents(state) {
  return getRosterData(state).learners || emptyArray;
}

export function getRosterData(state) {
  return state.bridge[GET_ROSTER].data;
}

export function isRosterLoading(state) {
  return state.bridge[GET_ROSTER].isFetching;
}

export function hasRosterError(state) {
  return state.bridge[GET_ROSTER].hasError;
}



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/roster/selectors.js